var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { forwardRef, useRef } from 'react';
import cx from 'classnames';
import styles from './Chip.module.scss';
import { Typography } from '../../../foundations/typography';
/**
 * @tdr
 */
export var ChipComponent = function (_a, ref) {
    var _b;
    var _c;
    var _d = _a.colour, colour = _d === void 0 ? 'grey' : _d, _e = _a.small, small = _e === void 0 ? false : _e, _f = _a.active, active = _f === void 0 ? false : _f, leadingIcon = _a.leadingIcon, trailingIcon = _a.trailingIcon, onClick = _a.onClick, onFocus = _a.onFocus, productChip = _a.productChip, className = _a.className, children = _a.children, rest = __rest(_a, ["colour", "small", "active", "leadingIcon", "trailingIcon", "onClick", "onFocus", "productChip", "className", "children"]);
    var localRef = useRef(null);
    var chipRef = (_c = ref) !== null && _c !== void 0 ? _c : localRef;
    var renderAsButton = !!onClick;
    var classNames = cx(styles.chip, styles[colour], (_b = {},
        _b[styles.active] = active,
        _b[styles.small] = small,
        _b[styles.button] = renderAsButton,
        _b[styles.productChip] = productChip,
        _b), className);
    var handleFocus = function () {
        if (onFocus && chipRef.current) {
            onFocus(chipRef);
        }
    };
    return (React.createElement(Typography, __assign({ component: (renderAsButton ? 'button' : 'span'), onFocus: renderAsButton ? handleFocus : undefined, className: classNames, styleAs: "paragraphExtraSmall", noMargins: true, onClick: onClick, ref: chipRef, "aria-pressed": renderAsButton ? active : undefined, "data-testid": "typography" }, rest),
        !!leadingIcon && (React.createElement("span", { className: styles.leadingIcon, "data-testid": "chip-leading-icon" }, productChip ? React.cloneElement(leadingIcon, { size: 'xsmall' }) : leadingIcon)),
        children,
        !!trailingIcon && (React.createElement("span", { className: styles.trailingIcon, "data-testid": "chip-trailing-icon" }, productChip ? React.cloneElement(trailingIcon, { size: 'xsmall' }) : trailingIcon))));
};
export var Chip = forwardRef(ChipComponent);
//# sourceMappingURL=index.js.map